// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2bajk888APCDwEN-wbzO4b"};